import { render, staticRenderFns } from "./showApproveDoc.vue?vue&type=template&id=00fdf3aa&scoped=true&"
import script from "./showApproveDoc.vue?vue&type=script&lang=js&"
export * from "./showApproveDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fdf3aa",
  null
  
)

export default component.exports